import CompanyPage from 'src/components/pages/Company/CompanyPage/CompanyPage';

export default CompanyPage;
